import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-6 text-black text-body2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row text-body1 text-weight-bold text-black" }, " Avvikelse ", -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-6 q-pt-md column" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-caption text-grey-7" }, "Vagn", -1)
const _hoisted_7 = { class: "col-6 q-pt-md column" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-caption text-grey-7" }, "Kategori", -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12 q-pt-md column" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-caption text-grey-7" }, "Beskrivning", -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-12 q-pt-md column" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-caption text-grey-7" }, "Skapad av", -1)
const _hoisted_15 = { class: "col-12 q-pt-md column" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-caption text-grey-7" }, "Skapad", -1)
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-6 q-pt-md column" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-caption text-grey-7" }, "Utförd", -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-6 q-pt-md column" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-caption text-grey-7" }, "Utförd beskrivning", -1)
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = {
  key: 1,
  style: {"min-width":"100%","min-height":"400px"},
  class: "rounded-borders shadow-1 flex items-center justify-center column"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-grey-7 q-mt-sm" }, "Inget foto", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeviationCheckDialog = _resolveComponent("DeviationCheckDialog")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showConfirmDeviationModal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showConfirmDeviationModal) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        (_ctx.showConfirmDeviationModal)
          ? (_openBlock(), _createBlock(_component_DeviationCheckDialog, {
              key: 0,
              deviation: _ctx.deviation,
              onClose: _ctx.onConfirmCompleteDeviation
            }, null, 8, ["deviation", "onClose"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_card, { style: {"max-width":"1000px","min-width":"800px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createTextVNode(" " + _toDisplayString(_ctx.deviation.vehicle.name) + " - " + _toDisplayString(_ctx.deviation.vehicle.type), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(_ctx.deviation.deviationType.description), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(_ctx.deviation.description), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.deviation.userEmail), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.deviation.created)), 1)
                  ])
                ]),
                _createVNode(_component_q_separator, { class: "q-mt-md q-mr-md" }),
                (_ctx.deviation.completed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createTextVNode(" " + _toDisplayString(_ctx.deviation.completed), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createTextVNode(" " + _toDisplayString(_ctx.deviation.completedDescription), 1)
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_23, [
                (_ctx.photoSrc)
                  ? (_openBlock(), _createBlock(_component_q_img, {
                      key: 0,
                      class: "rounded-borders shadow-1",
                      style: {"min-width":"100%","min-height":"400px"},
                      src: _ctx.photoSrc,
                      fit: "scale-down"
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(_component_q_icon, {
                        size: "md",
                        color: "grey-7",
                        name: "mdi-image-off-outline"
                      }),
                      _hoisted_25
                    ]))
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_q_separator),
        _createVNode(_component_q_card_actions, { align: "right" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, {
              flat: "",
              label: "Stäng",
              color: "primary",
              onClick: _ctx.close
            }, null, 8, ["onClick"]),
            (!_ctx.deviation.completed)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  flat: "",
                  label: "Utför",
                  color: "positive",
                  onClick: _ctx.onComplete
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}